import React from 'react'
import { Button } from '../ui/button';
import BackBtn from './BackBtn';

interface MainHeadingProps {
    title: string;
    subtitle?: string;
    isBackButtonVisible?: boolean;
    buttonText?: string;
    buttonIcon?: React.ReactNode;
    onClick?: () => void;
    actions?: React.ReactNode;
}

const MainHeading: React.FC<MainHeadingProps> = ({
    title,
    subtitle,
    isBackButtonVisible,
    buttonText,
    buttonIcon,
    onClick,
    actions,
}) => {
    return (
        <div className='w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-5 flex-wrap'>
            <div className='flex items-start gap-3 md:gap-4 flex-wrap'>
                {isBackButtonVisible && (
                    <div className='mt-0.5 shrink-0'>
                        <BackBtn />
                    </div>
                )}
                <div className='space-y-1'>
                    <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground leading-tight">{title}</h1>
                    {subtitle && <p className="text-muted-foreground text-sm md:text-base">{subtitle}</p>}
                </div>
            </div>

            {actions ? (
                <div className="flex items-center gap-2.5 w-full sm:w-auto shrink-0">
                    {actions}
                </div>
            ) : (
                buttonText && (
                    <Button onClick={onClick}>
                        {buttonIcon && buttonIcon} {buttonText}
                    </Button>
                )
            )}
        </div>
    )
}

export default MainHeading